<template>
  <div class="row vehicle-detail">
    <div class="col-lg-4 vehicle-detail-label">{{ label }}:</div>
    <div class="col-lg-8 vehicle-detail-value">
      {{ value }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      required: true
    }
  }
};
</script>

<style>
.vehicle-detail {
  margin-bottom: 7px;
}

.vehicle-detail-label {
  font-weight: bold;
}
</style>
